import { defineComponent as _defineComponent } from 'vue'
import maropostLogoUrl from '@/assets/maropost-logo.svg'
import { EXPLORE_MORE_PRODUCTS } from '@/constants/productExplore.constants'

// --------------------------------------------------
// Data
// --------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductExplore',
  setup(__props, { expose: __expose }) {
  __expose();


// --------------------------------------------------
// Imports
// --------------------------------------------------
const exploreMore = EXPLORE_MORE_PRODUCTS

const __returned__ = { exploreMore, get maropostLogoUrl() { return maropostLogoUrl } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})